/**
 * @module modules/word-cloud-sk
 * @description <h2><code>word-cloud-sk</code></h2>
 *
 * Displays the key-value pairs found in a cluster, and also
 * shows the relative frequency of how often they appear.
 *
 * @example
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "WordCloudSk", {
    enumerable: true,
    get: function() {
        return WordCloudSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _repeat = require("lit/directives/repeat.js");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let WordCloudSk = class WordCloudSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        return (0, _lit.html)`
      <table>
        ${(0, _repeat.repeat)(this.items, (item)=>item.value, (item)=>(0, _lit.html)`
            <tr>
              <td class="value">${item.value}</td>
              <td class="textpercent">${item.percent}%</td>
              <td class="percent" title="${item.percent}%">
                <div style="width: ${item.percent}px"></div>
              </td>
            </tr>
          `)}
      </table>
    `;
    }
    constructor(...args){
        super(...args);
        /** A serialized slice of ValuePercent.

      For example:

      [
        {value:"config=565", percent: 60},
        {value:"config=8888", percent: 40},
        {value:"cpu_or_gpu=cpu", percent: 20},
        {value:"cpu_or_gpu=gpu", percent: 10},
      ]
  */ this.items = [];
    }
};
_ts_decorate([
    (0, _decorators.property)({
        type: Array
    }),
    _ts_metadata("design:type", Array)
], WordCloudSk.prototype, "items", void 0);
WordCloudSk = _ts_decorate([
    (0, _decorators.customElement)('word-cloud-sk')
], WordCloudSk);
